import { PageChrome } from "@/components/chrome/PageChrome";
import { DangerZoneSection } from "@/components/settings/organization/DangerZoneSection";
import { IdentityPanel } from "@/components/settings/organization/IdentityPanel";
import { useOrganization } from "@/lib/auth";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/settings/organization")({
  component: OrganizationPage,
});

function OrganizationPage() {
  const { organization } = useOrganization();
  const orgName = organization?.name ?? "";
  return (
    <div className="flex flex-col flex-1 overflow-hidden">
      <PageChrome
        crumbs={[
          { label: orgName || "Org", to: "/dashboard" },
          { label: "Settings" },
          { label: "Organization" },
        ]}
        title="Organization"
        helper="Identity, data export, and irreversible actions."
      />
      <div className="flex-1 overflow-auto px-4 sm:px-7 py-6">
        <div className="flex flex-col gap-7">
          <IdentityPanel />
          <DangerZoneSection />
        </div>
      </div>
    </div>
  );
}
